module.exports = __webpack_public_path__ + "static/media/standard_living_room.26f0220e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/standard_living_room.png
// module id = 797
// module chunks = 0